import { MensajeUsuario } from 'src/app/util/mensajes/mensajeUsuario';
import { FiltroCoCobranza } from './../../cocobranza/dominio/FiltroCoCobranza';
import { DtoCotizacion } from './../dominio/DtoCotizacion';
import { FiltroCoCotizacion } from './../dominio/FiltroCoCotizacion';
import { Injectable, Inject } from '@angular/core';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
import { DtoCotizacionGenerarPedido } from '../dominio/DtoCotizacionGenerarPedido';
import { FiltroGenerarPedido } from '../dominio/FiltroGenerarPedido';
import { DtoPersonamast } from 'src/app/erp/core/personamast/dominio/DtoPersonamast';
import { CoCotizacion, CoCotizacionPk } from '../dominio/CoCotizacion';
import { UError } from '../../../../util/uerror';
import { UHttpsClient } from 'src/app/seguridad/seguridad/uhttpsClient';

@Injectable()
export class CoCotizacionServicio {

    private url = `${this.config.getEnv('proxy')}spring/comercial/cocotizacion/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient,private config: AppConfig) { }

    public listarCotizacionesPaginacion(filtro: FiltroCoCotizacion): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarCotizacionesPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    imprimir(filtro: FiltroCoCotizacion
        ): Promise<ArrayBuffer> {
    
            return this.http.post(`${this.url}imprimir`, 
               filtro
            ,
                {
                    headers: this.headers, responseType: 'blob' as 'json'
                })
                .toPromise()
                .then(response => response as ArrayBuffer)
                .catch(error => Promise.reject(error.json() as UError));
        }

    public wfSetprecios(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}wfSetprecios`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    public validarCotizacion(bean: CoCotizacion): Promise<MensajeUsuario[]> {
        return this.http.post(`${this.url}validarCotizacion`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as MensajeUsuario[];
            })
            .catch(error => null);
    }

    public listarCobranzaPaginacion(filtro: FiltroCoCobranza): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarCobranzaPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    public obtenerCompletoPorId(pk: CoCotizacionPk): Promise<CoCotizacion> {
        return this.http.post(`${this.url}obtenerCompletoPorId`, pk,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    public registrar(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}registrar`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    solicitudAnular(bean: DtoCotizacion): Promise<any> {
        return this.http.post(`${this.url}solicitudAnularCotizacion`, bean,{headers: this.headers})
            .toPromise()
            .then(response => response as DtoCotizacion)
            .catch(error => null);
    }

    solicitudAprobar(bean: DtoCotizacion): Promise<any> {
        return this.http.post(`${this.url}solicitudAprobarCotizacion`, bean,{headers: this.headers})
            .toPromise()
            .then(response => response as DtoCotizacion)
            .catch(error => null);
    }

    public listarCotizacionesGenerarPedido(bean: FiltroGenerarPedido): Promise<DtoCotizacionGenerarPedido[]> {
        return this.http.post(`${this.url}listarCotizacionesGenerarPedido`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoCotizacionGenerarPedido[];
            })
            .catch(error => []);
    }
    public nuevaCotizacion(bean: DtoPersonamast): Promise<CoCotizacion> {
        return this.http.post(`${this.url}nuevaCotizacion`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    public registrarDetalle(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}registrarDetalle`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    public obtenerAutorizacionDescuento04(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}obtenerAutorizacionDescuento04`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => new CoCotizacion);
    }

    public actualizarCliente(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}actualizarCliente`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    validar(bean: DtoCotizacion): Promise<any> {
        return this.http.post(`${this.url}validar`, bean,{headers: this.headers})
            .toPromise()
            .then(response => response as number)
            .catch(error => null);
    }

    public eliminarDetalle(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}eliminarDetalle`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }

    public calcularDescuentos(bean: CoCotizacion): Promise<CoCotizacion> {
        return this.http.post(`${this.url}calcularDescuentos`, bean,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoCotizacion;
            })
            .catch(error => null);
    }
}

